import { InputAdornment, Stack, TextField } from '@mui/material'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { TaskRecurrenceType } from 'Generated/graphql-types'
import { OnUpdateOptions } from '../types'

type IntervalNumberInputProps = {
  recurrenceType: TaskRecurrenceType
  frequency: string
  onUpdateOptions: OnUpdateOptions
}

export const FrequencyInput = ({
  recurrenceType,
  frequency,
  onUpdateOptions,
}: IntervalNumberInputProps) => {
  const iconStyles = {
    cursor: 'pointer',
    fontSize: '14px',
  }

  const handleArrowClick = (type: 'increment' | 'decrement') => {
    const value =
      type === 'increment' ? Number(frequency) + 1 : Number(frequency) - 1
    onUpdateOptions({
      key: 'frequency',
      value: String(value <= 0 ? 1 : value),
    })
  }

  return (
    <TextField
      disabled={recurrenceType === TaskRecurrenceType.Quarterly}
      id='task-modal-v2-set-interval-number-input'
      onChange={({ target }) =>
        target.value === '0'
          ? onUpdateOptions({ key: 'frequency', value: '1' })
          : onUpdateOptions({
              key: 'frequency',
              value: target.value,
            })
      }
      sx={{ width: '90px' }}
      type='number'
      value={frequency}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <Stack direction='column'>
              <KeyboardArrowUpIcon
                onClick={() => handleArrowClick('increment')}
                sx={iconStyles}
              />
              <KeyboardArrowDownIcon
                onClick={() => handleArrowClick('decrement')}
                sx={iconStyles}
              />
            </Stack>
          </InputAdornment>
        ),
      }}
    />
  )
}
